import { createGlobalState } from '@vueuse/core'
import { useEntraAuthentication } from './useEntraAuthentication'
import { computed } from 'vue'
import { clearAllStores } from '@/store'

export const useAuth = createGlobalState(() => {
  const {
    isAuthenticated: entraAuthenticated,
    getAccessToken: getEntraAccessToken,
    handleRedirect: handleEntraRedirect,
    logout: entraLogout
  } = useEntraAuthentication()

  const isAuthenticated = computed(() => {
    return entraAuthenticated.value
  })

  const getAccessToken = async () => {
    return await getEntraAccessToken()
  }
  const getAuthenticated = async () => {
    const isAuthenticated = !!(await getAccessToken())
    return isAuthenticated
  }
  const handleRedirect = async () => {
    return await handleEntraRedirect()
  }
  const logout = async () => {
    clearAllStores()
    await entraLogout()
  }

  return {
    isAuthenticated,
    getAccessToken,
    getAuthenticated,
    handleRedirect,
    logout
  }
})
